import { useLocation } from 'react-router-dom';

import '@esri/calcite-components/components/calcite-button';
import '@esri/calcite-components/components/calcite-icon';
import '@esri/calcite-components/components/calcite-navigation-logo';

import { AppResource } from '@config/config.jsx';

import './PgPubLogin.css';

const PgPubLogin = () => {
  const location = useLocation();

  // Get the stored path from location state
  const from =
    location.state?.from ||
    location.state?.returnTo ||
    '/';

  console.log(
    'Login page - Return path:',
    from
  );

  const handleLogin = async () => {
    console.log(
      'handleLogin - Storing return path:',
      from
    );

    try {
      // Use localStorage to store the return path before redirecting.
      // The LoginCallback component will use this value to navigate.
      localStorage.setItem(
        'returnTo',
        from
      );

      // Redirect the user to the external login provider
      window.location.href =
        AppResource.non_ssoauth_url;
    } catch (error) {
      console.error(
        'Login failed:',
        error
      );
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">

        /

        <h1>
          Welcome to NIOGEMS Application
        </h1>

        <p>
          Access and manage your data securely
          with Login.gov authentication.
        </p>

        <calcite-button
          onClick={handleLogin}
          scale="l"
          icon-start="sign-in"
        >
          Sign in with Login.gov
        </calcite-button>

        <div className="login-footer">
          By signing in, you agree to our Terms
          of Service and Privacy Policy
        </div>

      </div>
    </div>
  );
};

export default PgPubLogin;